if(typeof _GIRL_CONF['ashley']['game_memory']=='undefined'){_GIRL_CONF['ashley']['game_memory']={};};
_GIRL_CONF['ashley']['game_memory']['face']={left:586,top:98,width:109,height:151};
_GIRL_CONF['ashley']['game_memory']['hair']={left:482,top:13,width:241,height:326};
_GIRL_CONF['ashley']['game_memory']['handl']={left:482,top:260,width:331,height:328};
_GIRL_CONF['ashley']['game_memory']['handr']={left:667,top:196,width:173,height:290};
_GIRL_CONF['ashley']['game_memory']['item1']={left:186,top:247,width:228,height:438};
_GIRL_CONF['ashley']['game_memory']['item2']={left:941,top:306,width:146,height:293};
_GIRL_CONF['ashley']['game_memory']['item3']={left:333,top:594,width:662,height:154};
_GIRL_CONF['ashley']['game_memory']['titl']={left:570,top:302,width:138,height:130};
_GIRL_CONF['ashley']['game_memory']['titr']={left:667,top:293,width:137,height:121};
